import { useNavigate } from 'react-router-dom';

import { purgeClientSession } from '@/shared/auth/purgeClientSession';
import { PATH } from '@/shared/constants';

export const useAuth = () => {
  const navigate = useNavigate();

  const logout = async () => {
    purgeClientSession();
    navigate(PATH.AUTH.SIGNIN, { replace: true });
  };

  return { logout };
};
